import { useState } from 'react';

/** Было ли значение `true` на прошлом рендере. */
export function useWasTrue(v: boolean): boolean {
  const [prev, setPrev] = useState(v);
  const [was, setWas] = useState(false);
  if (prev !== v) {
    setWas(prev);
    setPrev(v);
  }
  return was;
}
